<template>
    <v-container grid-list-sm text-xs-left>
        <v-layout column>
            <v-flex xs12>
                <v-card class="rounded">
                    <v-flex xs12 px-4 py-2>
                        <FileInput
                                ref="inputFile"
                                :options="excelInputOptions"
                                :on-upload-callback="uploadFile"
                        />
                    </v-flex>

                </v-card>
            </v-flex>

            <v-flex class="pt-5 mt-5 text-xs-center">
                <span class="title">{{message}}</span>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import FileInput from "@/components/Inputs/FileInput";
    import UrlsService from "@/helpers/UrlsService.js";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";

    export default {
        name: "UploadStartups",
        components: {FileInput},
        data() {
            return {
                message: "",
                excelInputOptions: {
                    id: "startup-upload",
                    formType: "text",
                    accept: ".xls, .xlsx, .json",
                    disabled: false,
                    capture: false,
                    multiple: false,
                    details: {show: true},
                    data: {
                        title: this.$t("training.conversation.innovation.uploadTitle"),
                        subtitle: this.$t("training.conversation.innovation.uploadSubtitle"),
                        upload: this.$t("training.conversation.innovation.uploadMessage"),
                        buttonTitle: this.$t("training.conversation.innovation.uploadButton"),
                        buttonColor: "teal",
                    },
                },

            };
        },
        methods: {
            uploadFile(uploadedFile) {
                if (uploadedFile.files[0].name !== "" && (uploadedFile.files[0].extension === "xlsx"|| uploadedFile.files[0].extension === "xls")) {
                    let requestUrl = {
                        url: UrlsService.uploadStartups,
                        timeout: TimeService.secondsToMillis(0),
                    };
                    let requestData = {
                        interactionData: {
                            text:this.$refs.inputFile.opCoValue
                        },
                    };

                    let requestObject = {
                        type: "upload",
                        urlsInfo: requestUrl,
                        data: {
                            data: requestData,
                            file: uploadedFile.files[0].data,
                        },
                    };
                    let messages = {
                        title: "Upload File",
                        loading: "Waiting for upload...",
                        error: "Cannot upload your file...",
                    };
                    let options = {
                        loadingType: "fullscreen",
                        timeout: TimeService.secondsToMillis(0),
                    };
                    APILoaderDecoratorService.setLoader(requestObject, messages, options)
                        .then(responseSuccess => {
                            let response = responseSuccess;
                            if(response.response.duplicatedStartups.length===0){
                                this.message = "Startups correctly uploaded";
                            }
                            else {
                                this.message = "The following startups have not been uploaded because they are already present with that named: " + response.response.duplicatedStartups.join();
                            }


                        })
                        .catch(err =>{
                            this.message = "Error during the upload";
                        });

                }
                else if(uploadedFile.files[0].name !== "" && (uploadedFile.files[0].extension === "json")){
                    let requestUrl = {
                        url: UrlsService.uploadStartupsJson,
                        timeout: TimeService.secondsToMillis(0),
                    };
                    let requestData = {
                        interactionData: {
                            text:this.$refs.inputFile.opCoValue
                        },
                    };

                    let requestObject = {
                        type: "upload",
                        urlsInfo: requestUrl,
                        data: {
                            data: requestData,
                            file: uploadedFile.files[0].data,
                        },
                    };
                    let messages = {
                        title: "Upload File",
                        loading: "Waiting for upload...",
                        error: "Cannot upload your file...",
                    };
                    let options = {
                        loadingType: "fullscreen",
                        timeout: TimeService.secondsToMillis(0),
                    };
                    APILoaderDecoratorService.setLoader(requestObject, messages, options)
                        .then(responseSuccess => {
                            let response = responseSuccess;
                            if(response.response.duplicatedStartups.length===0){
                                this.message = "Startups correctly uploaded";
                            }
                            else {
                                this.message = "The following startups have not been uploaded because they are already present with that named: " + response.response.duplicatedStartups.join();
                            }

                        })
                        .catch(err =>{
                            this.message = "Error during the upload";
                        });

                }
            },

        },
    };
</script>

<style lang="scss">

</style>
